import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadCorporateSignupConfigData, loadCorporateSignupConfigDataSuccess, loadCorporateSignupConfigDataFailure } from '../actions/corporateSignupConfig.actions';
import { environment } from 'src/environments/environment';
import { selectCorporateSignupConfigData } from '../selectors/corporateSignupConfig.selector';
import { select, Store } from '@ngrx/store';

@Injectable()
export class CorporateSignupConfigEffects {
  loadCorporateSignupConfigData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadCorporateSignupConfigData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadCorporateSignupConfigData),
        withLatestFrom(this.store.pipe(select(selectCorporateSignupConfigData))),
        switchMap(([action, currentData]) => {
          console.log({currentData})
          if (currentData != undefined && Object.keys(currentData).length > 0) {
            console.log('Data already in store, no need to call API');
            console.log('return old fetch', new Date().toISOString())
            return;
          }
          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };
          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('new fetch', new Date().toISOString())
              return loadCorporateSignupConfigDataSuccess({ corporateSignupConfigData: data.data });
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadCorporateSignupConfigDataFailure({ error: errorMessage })]; // Dispatch failure on error
            })
          );
        })
      )
    );
  }

  private getApiEndpoint(): string {
    return `/api/ap/admin/corporateSignup/formConfig`
    // https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporateSignup/formConfig
  }
}
